export default {
    checkbox: 'Осмотр товара произведен',
    feedback: 'Поле обязательно для заполнения!',
    saveButton: 'Сформировать возврат',
};